export function formatProductBarcodeList(barcode: string | undefined): string {
	if (barcode == null || !String(barcode).trim()) {
		return '';
	}
	return String(barcode)
		.split(/[;,]+/)
		.map((s: string): string => s.trim())
		.filter(Boolean)
		.join(', ');
}

export function productSizeAspectRatio(width: number | undefined, height: number | undefined): number | undefined {
	if (width == null || height == null) {
		return undefined;
	}
	if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
		return undefined;
	}
	return width / height;
}

export function deriveImageFileNameFromSrc(src: string, fallback = 'image.jpg'): string {
	if (!src) return fallback;
	if (src.startsWith('data:image/')) {
		const ext: string = src.slice('data:image/'.length).split(';', 1)[0] || 'jpg';
		return `image.${ext}`;
	}
	try {
		const url = new URL(src, window.location.origin);
		const raw: string = decodeURIComponent(url.pathname.split('/').pop() || '');
		return raw || fallback;
	} catch {
		return fallback;
	}
}

export async function resolveImageByteSize(src: string): Promise<number | null> {
	if (!src) return null;
	try {
		const response: Response = await fetch(src);
		if (!response.ok) return null;
		const blob: Blob = await response.blob();
		return blob.size ?? null;
	} catch {
		return null;
	}
}

export function revokeBlobObjectUrl(url: string | null | undefined): void {
	if (url?.startsWith('blob:')) {
		URL.revokeObjectURL(url);
	}
}
